"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("@completeanatomy/config");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../../atoms");
const uploadImage_1 = require("../../utils/uploadImage");
function GroupEditInfo({ group, currentGroupInfo, onSave, isEdit = false, setGroupInfo, isLoading, isSaved, setIsSaved, }) {
    const config = (0, config_1.useConfigService)();
    const { name, information, avatar } = currentGroupInfo;
    const baseImageUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    const onChange = (key, value) => {
        setGroupInfo(Object.assign(Object.assign({}, currentGroupInfo), { [key]: value }));
        setIsSaved(false);
    };
    const onAvatarChange = () => __awaiter(this, void 0, void 0, function* () {
        const image = yield (0, uploadImage_1.uploadImage)();
        onChange('avatar', image);
    });
    const isSaveButtonVisible = (0, react_1.useMemo)(() => {
        const isNameEmpty = !name;
        return (!isNameEmpty &&
            ((group === null || group === void 0 ? void 0 : group.name) !== name ||
                (group === null || group === void 0 ? void 0 : group.information) !== information ||
                (group === null || group === void 0 ? void 0 : group.avatar) !== avatar));
    }, [
        group === null || group === void 0 ? void 0 : group.name,
        group === null || group === void 0 ? void 0 : group.information,
        group === null || group === void 0 ? void 0 : group.avatar,
        name,
        information,
        avatar,
    ]);
    let image = '';
    if (avatar) {
        image = (avatar === null || avatar === void 0 ? void 0 : avatar.startsWith('data:image')) ? avatar : baseImageUrl + avatar;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupEditInfo_Container', children: [(0, jsx_runtime_1.jsxs)(AvatarContainer, { "data-e2e": 'GroupEditInfo_AvatarContainer', children: [(0, jsx_runtime_1.jsx)(UserAvatar, { image: image, group: true, "data-e2e": 'GroupEditInfo_UserAvatar' }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'GroupEditInfo_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.profile.avatar) }), (0, jsx_runtime_1.jsx)(AvatarButton, { onClick: onAvatarChange, "data-e2e": 'GroupEditInfo_AvatarButton', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.profile.change) })] }), (0, jsx_runtime_1.jsxs)(FieldsContainer, { "data-e2e": 'GroupEditInfo_FieldsContainer', children: [(0, jsx_runtime_1.jsx)(FieldTitle, { "data-e2e": 'GroupEditInfo_FieldTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.profile.groupName) }), (0, jsx_runtime_1.jsx)(FieldInput, { value: name, maxLength: 100, onChange: (value) => onChange('name', value), "data-e2e": 'GroupEditInfo_FieldInput' }), (0, jsx_runtime_1.jsx)(DescriptionTitle, { "data-e2e": 'GroupEditInfo_DescriptionTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.profile.description) }), (0, jsx_runtime_1.jsx)(FieldInput, { value: information, maxLength: 500, onChange: (value) => onChange('information', value), "data-e2e": 'GroupEditInfo_FieldInput' }), (0, jsx_runtime_1.jsxs)(Counter, { "data-e2e": 'GroupEditInfo_Counter', children: [information === null || information === void 0 ? void 0 : information.length, "/500"] })] })] }), isSaveButtonVisible && !isSaved && ((0, jsx_runtime_1.jsxs)(SaveButton, { onClick: () => onSave(currentGroupInfo), "data-e2e": 'GroupEditInfo_SaveButton', children: [(0, jsx_runtime_1.jsx)(SpinnerContainer, { "data-e2e": 'GroupEditInfo_SpinnerContainer', children: isLoading && (0, jsx_runtime_1.jsx)(atoms_1.Spinner, { "data-e2e": 'GroupEditInfo_Spinner' }) }), (0, jsx_runtime_1.jsx)(TextContainer, { "data-e2e": 'GroupEditInfo_TextContainer', children: isEdit
                            ? (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.profile.update)
                            : (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.createGroup) })] })), isSaved && ((0, jsx_runtime_1.jsx)(StyledCheckmark, { size: ui_1.ButtonSize.Small, "data-e2e": 'GroupEditInfo_StyledCheckmark', children: (0, jsx_runtime_1.jsx)(Checkmark, { name: ui_1.Icons.Checkmark, "data-e2e": 'GroupEditInfo_Checkmark' }) }))] }));
}
exports.default = GroupEditInfo;
const Container = styled_components_1.default.div `
  display: flex;

  box-sizing: border-box;

  width: 100%;

  padding: 20px;
`;
const AvatarContainer = styled_components_1.default.div `
  display: flex;
  flex-basis: 40%;
  flex-direction: column;
`;
const UserAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 120px;
  height: 120px;

  margin: 50px auto 20px auto;

  cursor: pointer;
`;
const Title = styled_components_1.default.div `
  margin: 0 auto;

  font-size: 12px;
  text-align: center;

  color: ${props => props.theme.text};
`;
const ProfileButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  color: ${props => props.disabled ? props.theme.disabled : props.theme.white};

  background: none;

  border: 1px solid
    ${props => (props.disabled ? props.theme.disabled : props.theme.white)};
`;
const AvatarButton = (0, styled_components_1.default)(ProfileButton) `
  margin: 25px auto 0;
  padding: 15px 20px;

  font-size: 12px;
`;
const FieldsContainer = styled_components_1.default.div `
  display: flex;
  flex-basis: 50%;
  flex-direction: column;
`;
const FieldTitle = styled_components_1.default.div `
  margin: 0 auto 10px 0;

  color: ${props => props.theme.text};

  font-size: 12px;
`;
const DescriptionTitle = (0, styled_components_1.default)(FieldTitle) `
  margin-top: 30px;
`;
const FieldInput = (0, styled_components_1.default)(ui_1.Input) `
  width: 100%;

  padding: 0 0 5px 0;

  font-size: 16px;

  border-bottom: 1px solid ${props => props.theme.fieldBorder};
`;
const Counter = styled_components_1.default.div `
  width: 100%;

  padding-top: 5px;

  color: ${props => props.theme.textSecondary};

  font-size: 10px;
  text-align: right;
`;
const SaveButton = (0, styled_components_1.default)(ProfileButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 25px auto;
  padding: 0;

  font-size: 12px;
  text-transform: uppercase;

  width: 250px;
  height: 50px;
`;
const Checkmark = (0, styled_components_1.default)(ui_1.Icon) `
  width: 40px;
  height: 40px;

  color: ${props => props.theme.white};
`;
const StyledCheckmark = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  display: flex;
  align-items: center;

  margin: 2em auto 0;
  padding: 0;

  width: 40px;
  height: 40px;

  border-radius: 20px;
`;
const SpinnerContainer = styled_components_1.default.div `
  margin-right: auto;
  width: 20px;
`;
const TextContainer = styled_components_1.default.div `
  text-align: left;
  position: relative;
  margin: auto;
  left: -33px;
`;
